import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Link } from '@mui/material';
const TextWithSeachHighlight = ({ text, searchTerm }) => {
    const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const searchMatches = [];
    if (searchTerm) {
        const searchRegex = new RegExp(escapeRegExp(searchTerm), 'gi');
        Array.from(text.matchAll(searchRegex)).forEach((m) => {
            if (m.index !== undefined) {
                searchMatches.push({ start: m.index, end: m.index + m[0].length });
            }
        });
    }
    const urlRegex = new RegExp('((https?:\\/\\/)?'
        + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'
        + '((\\d{1,3}\\.){3}\\d{1,3}))'
        + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'
        + '(\\?[;&a-z\\d%_.~+=-]*)?'
        + '(\\#[-a-z\\d_]*)?)', 'ig');
    const urlMatches = [];
    Array.from(text.matchAll(urlRegex)).forEach((m) => {
        if (m.index !== undefined) {
            urlMatches.push({ start: m.index, end: m.index + m[0].length, url: m[0] });
        }
    });
    const boundaries = new Set();
    boundaries.add(0);
    boundaries.add(text.length);
    searchMatches.forEach((interval) => {
        boundaries.add(interval.start);
        boundaries.add(interval.end);
    });
    urlMatches.forEach((interval) => {
        boundaries.add(interval.start);
        boundaries.add(interval.end);
    });
    const sortedBoundaries = Array.from(boundaries).sort((a, b) => a - b);
    const segments = sortedBoundaries.slice(0, -1).map((boundary, i) => {
        const start = boundary;
        const end = sortedBoundaries[i + 1];
        const segText = text.slice(start, end);
        const inSearch = searchMatches.some((interval) => start >= interval.start && end <= interval.end);
        const urlInterval = urlMatches.find((interval) => start >= interval.start && end <= interval.end);
        return { text: segText, inSearch, url: urlInterval ? urlInterval.url : null };
    });
    // Render:
    //  - If the segment is part of a URL, render it inside a <Link> component.
    //  - If it also matches the search term, wrap it with a <mark> inside the link.
    //  - If it’s not a URL but matches the search term, wrap it with a <mark>.
    //  - Otherwise, render it as plain text.
    const renderedSegments = segments.map((seg, idx) => {
        if (seg.url) {
            const href = seg.url.startsWith('http') ? seg.url : `http://${seg.url}`;
            return (_jsx(Link
            // eslint-disable-next-line react/no-array-index-key
            , { href: href, target: "_blank", rel: "noopener noreferrer", underline: "hover", children: seg.inSearch ? _jsx("mark", { style: { backgroundColor: 'yellow' }, children: seg.text }) : seg.text }, `link-${seg.text}-${idx}`));
        }
        if (seg.inSearch) {
            return (
            // eslint-disable-next-line react/no-array-index-key
            _jsx("mark", { style: { backgroundColor: 'yellow' }, children: seg.text }, `mark-${seg.text}-${idx}`));
        }
        // eslint-disable-next-line react/no-array-index-key
        return _jsx("span", { children: seg.text }, `n-${seg.text}-${idx}`);
    });
    return (_jsx(Typography, { variant: "body1", sx: { pt: 1, whiteSpace: 'pre-wrap' }, children: renderedSegments }));
};
export default TextWithSeachHighlight;
//# sourceMappingURL=TextWithSeachHighlight.js.map